/**
* Bootstrap Table German translation
* Author: Paul Mohr - Sopamo<p.mohr@sopamo.de>
*/

$.fn.bootstrapTable.locales['de-DE-custom'] = $.fn.bootstrapTable.locales['de'] = {
  formatCopyRows () {
    return 'Zeilen kopieren'
  },
  formatPrint () {
    return 'Drucken'
  },
  formatLoadingMessage () {
    return 'Lade, bitte warten'
  },
  formatRecordsPerPage (pageNumber) {
    return `${pageNumber} Zeilen pro Seite.`
  },
  formatShowingRows (pageFrom, pageTo, totalRows, totalNotFiltered) {
    if ($("#report-list").length > 0) {
      window.setTimeout(function() {
        console.log('attendees yas')
          //if (totalRows > 0) {
              // Show filtered rows separately again even though its shown in German.
              if ($(".filtered-entries").length > 0) {
                  if ($("#filiale-id").length > 0 && $("#filiale-id").val() === "all") {
                      // Calculate average Filialnews per Filiale dynamically based on rows shown
                      var report_filiale_ids = [];
                      // getData gives the data object being used in the table
                      $.each($('#report-list').bootstrapTable('getData'), function(index, elem) {
                          report_filiale_ids.push(
                              elem.filiale.trim()
                          );
                      });
                      // Get unique elements in the array
                      report_filiale_ids = report_filiale_ids.filter(function(elem, index, arr) {
                          return arr.indexOf(elem) === index;
                      });
                      if (report_filiale_ids.length > 0) {
                          $(".filtered-entries .total-number").html(totalRows);
                          $(".filtered-entries .average").html(
                              parseFloat(
                                  totalRows / report_filiale_ids.length
                              ).toPrecision(2)
                          );
                      }
                  }  // User-mode or a filiale is selected from admin-mode
                  else {
                      $(".filtered-entries .total-number").html(totalRows);
                      $(".filtered-entries .average").html(
                          parseFloat(totalRows).toPrecision(2)
                      );
                  }
              } // Event Calendar reporting
              else {
                  // Calculate average of attendees from events with registration
                  var total_attendees   = 0,
                      attendees_count   = 0,
                      // Calculate average events per Filiale dynamically based on rows shown
                      event_filiale_ids = [];

                  // getData gives the data object being used in the table
                  $.each($("#report-list").bootstrapTable('getData'), function(index, elem) {
                      var val = elem.attendees.trim();
                      console.log(val)
                      if (val !== "-") {
                          total_attendees+= parseInt(val);
                          attendees_count++;
                      }
                      if ($("#filiale-id").length > 0 && $("#filiale-id").val() === "all") {
                          // Collect Filial IDs
                          event_filiale_ids.push(
                              elem.filiale.trim()
                          );
                      }
                  });

                  if (attendees_count > 0) {
                      $(".total-number").html(total_attendees);
                      $(".average").html(
                          parseFloat(
                              total_attendees / attendees_count
                          ).toPrecision(2)
                      );
                  } else {
                      $(".total-number, .average").html(0);
                  }

                  if ($("#filiale-id").length > 0 && $("#filiale-id").val() === "all") {
                      // Get unique elements in the array
                      event_filiale_ids = event_filiale_ids.filter(function(elem, index, arr) {
                          return arr.indexOf(elem) === index;
                      });

                      $(".events-total-number").html(totalRows);
                      $(".events-average").html(
                          parseFloat(
                              totalRows / event_filiale_ids.length
                          ).toPrecision(2)
                      );
                  } else {
                      $(".events-total-number").html(totalRows);
                      $(".events-average").html(
                          parseFloat(totalRows).toPrecision(2)
                      );
                  }
              }
          //}
      }, 500);
  }
  return 'Zeige Zeile ' + pageFrom + ' bis ' + pageTo + ' von ' + totalRows + ' Zeile' + ((totalRows > 1) ? "n" : "")+".";
  },
  formatSRPaginationPreText () {
    return 'Vorherige Seite'
  },
  formatSRPaginationPageText (page) {
    return `Zu Seite ${page}`
  },
  formatSRPaginationNextText () {
    return 'Nächste Seite'
  },
  formatDetailPagination (totalRows) {
    return `Zeige ${totalRows} Zeile${(totalRows > 1) ? 'n' : ''}.`
  },
  formatClearSearch () {
    return 'Lösche Filter'
  },
  formatSearch () {
    return 'Suchen'
  },
  formatNoMatches () {
    return 'Keine passenden Ergebnisse gefunden'
  },
  formatPaginationSwitch () {
    return 'Verstecke/Zeige Nummerierung'
  },
  formatPaginationSwitchDown () {
    return 'Zeige Nummerierung'
  },
  formatPaginationSwitchUp () {
    return 'Verstecke Nummerierung'
  },
  formatRefresh () {
    return 'Neu laden'
  },
  formatToggle () {
    return 'Umschalten'
  },
  formatToggleOn () {
    return 'Normale Ansicht'
  },
  formatToggleOff () {
    return 'Kartenansicht'
  },
  formatColumns () {
    return 'Spalten'
  },
  formatColumnsToggleAll () {
    return 'Alle umschalten'
  },
  formatFullscreen () {
    return 'Vollbild'
  },
  formatAllRows () {
    return 'Alle'
  },
  formatAutoRefresh () {
    return 'Automatisches Neuladen'
  },
  formatExport () {
    return 'Datenexport'
  },
  formatJumpTo () {
    return 'Springen'
  },
  formatAdvancedSearch () {
    return 'Erweiterte Suche'
  },
  formatAdvancedCloseButton () {
    return 'Schließen'
  },
  formatFilterControlSwitch () {
    return 'Verstecke/Zeige Filter'
  },
  formatFilterControlSwitchHide () {
    return 'Verstecke Filter'
  },
  formatFilterControlSwitchShow () {
    return 'Zeige Filter'
  },
  formatAddLevel () {
    return 'Ebene hinzufügen'
  },
  formatCancel () {
    return 'Abbrechen'
  },
  formatColumn () {
    return 'Spalte'
  },
  formatDeleteLevel () {
    return 'Ebene entfernen'
  },
  formatDuplicateAlertTitle () {
    return 'Doppelte Einträge gefunden!'
  },
  formatDuplicateAlertDescription () {
    return 'Bitte doppelte Spalten entfenen oder ändern'
  },
  formatMultipleSort () {
    return 'Mehrfachsortierung'
  },
  formatOrder () {
    return 'Reihenfolge'
  },
  formatSort () {
    return 'Sortieren'
  },
  formatSortBy () {
    return 'Sortieren nach'
  },
  formatThenBy () {
    return 'anschließend'
  },
  formatSortOrders () {
    return {
      asc: 'Aufsteigend',
      desc: 'Absteigend'
    }
  }
}

$.extend($.fn.bootstrapTable.defaults, $.fn.bootstrapTable.locales['de-DE-custom'])
